<div id="home-container">
    <img class="mx-auto d-block" src="../../assets/img/logo_completo.jpg" alt="Traduco">
</div>
<app-credits></app-credits>